import type { CREDENTIAL_KEYS } from '../auth/constants';
import { Storage } from './Storage';

export const appUtilsStorage = new Storage<{
  [CREDENTIAL_KEYS.USER_ID]?: string;
}>();

export const trackingMarksStorage = new Storage<{
  'share-builder-viewed-source':
    | 'AllSharesList'
    | 'AssetAddedSuccessToast'
    | 'AutomaticRedirectAfterCreation'
    | 'ProjectNavSharesList'
    | 'ShareLinkPageEditShare'
    | 'QuickshareViewAllSettings'
    | 'QuickshareOpenEditor';
}>();
